import React from 'react'
import Performance from './components/Performance'
import ResetStateWithKey from './components/ResetStateWithKey'

const App = () => {
  return (
    <div>
        <ResetStateWithKey />
        <Performance/>
    </div>
  )
}

export default App